import { stripTags } from '@/components/utils/common';

function DOMLoaded() {
	console.info('Step2JS-DOMLoaded()');

	document.addEventListener("click", function(e) {
		const target = e.target;
		if (target.matches("input[type='checkbox'][name^='bookmark['][name$=']']")) {
			const checkboxes = document.querySelectorAll("input[type='checkbox'][name^='bookmark['][name$=']']:checked");
			const bookmark_cnt = checkboxes.length;
			if (bookmark_cnt > 8) {
				alert("즐겨찾기는 최대 8개까지 선택 가능합니다.");
				target.checked = false;

				const starSibling = target.nextElementSibling;
				if (starSibling && starSibling.classList.contains('star')) {
					starSibling.classList.remove('active');
				}

				e.preventDefault();
				return false;
			}
		}
	});

	/*
	document.addEventListener('click', function(e) {
		const target = e.target;
		if (target && target.matches('.delete_tr')) {
			const parentTr = target.closest('tr'); // 가장 가까운 tr 부모 요소 찾기
			if (parentTr) {
				parentTr.remove(); // 요소 제거
			}
		}
	});
	*/

	// 기공소 보철물에서만. (치과별x)
	document.addEventListener('click', function(event) {
		const target = event.target;
		/*
		if (target.classList.contains('del_item')) {
			const deletedIdxInput = document.querySelector('input[name="deleted_id"]');
			const dataIdx = target.getAttribute('data-id');
	
			if (deletedIdxInput.value === '') {
				deletedIdxInput.value = dataIdx;
			} else {
				deletedIdxInput.value += ',' + dataIdx;
			}
	
			const parentTr = target.closest('tr');
			if (parentTr) {
				parentTr.remove();
			}
		}
		*/
	});
}

/*
function prosthesis_list_add(list_num) {
	list_num = list_num + 1;
	const template = document.getElementById("prosthesis_list_template").innerHTML;

	const html = stripTags(template)
		.replace(/\[\[num\]\]/gi, list_num)
		.replace(/\[\[array_index\]\]/gi, list_num - 1);
	document.getElementById("prosthesis_list").insertAdjacentHTML('beforeend', html);

	// 230118 jamong
	window.scrollTo({ top: document.body.scrollHeight, behavior: 'smooth' });
}
*/

function chk_prosthesis_data() {
	const checkboxes = document.querySelectorAll("input[type='checkbox'][name^='bookmark['][name$=']']:checked");
	const bookmark_cnt = checkboxes.length;
	if (bookmark_cnt > 8) {
		alert("즐겨찾기는 최대 8개까지 선택 가능합니다.");
		return false;
	}

	return true;
}

function prosthesisSelectPopup(url) {
	const w = 650;
	const h = 800;
	const x = Math.round(window.screenX + (window.outerWidth / 2) - (w / 2));
	const y = Math.round(window.screenY + (window.outerHeight / 2) - (h / 2));
	window.open(url, '치과선택', 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y + ',toolbar=no,scrollbars=no,resizable=yes,status=no,menubar=no');
};

function prosthesisPrintPopup(url) {
	const w = 794;
	const h = 800;
	const x = Math.round(window.screenX + (window.outerWidth / 2) - (w / 2));
	const y = Math.round(window.screenY + (window.outerHeight / 2) - (h / 2));
	window.open(url, '보철물 출력', 'width=' + w + ',height=' + h + ',left=' + x + ',top=' + y + ',toolbar=no,scrollbars=yes,resizable=yes,status=no,menubar=no');
};
// prosthesis_list_add
export { DOMLoaded, chk_prosthesis_data, prosthesisSelectPopup, prosthesisPrintPopup };